/** @format */

import React from "react";
import { selectTheme } from "./themeSlice";
import { useAppSelector } from "../../app/hooks";
import { NavLink, Outlet } from "react-router-dom";
import { Navbar, Container } from "react-bootstrap";
import "./bs_theme.scss";

const Theme = () => {
  const theme = useAppSelector(selectTheme());

  return (
    <div id="theme-page" className="position-static">
      <Navbar bg={theme} expand="lg" data-bs-theme={theme}>
        <Container>
          <Navbar.Brand href="#home">Bootstrap Theme</Navbar.Brand>
          <NavLink className="nav-link" to="content">
            Content
          </NavLink>
          <NavLink className="nav-link" to="forms">
            Forms
          </NavLink>
          <NavLink className="nav-link" to="components">
            Components
          </NavLink>
        </Container>
      </Navbar>
      <div className="container">
        <div className="row">
          <div className="col">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Theme;
